export class CServiceLogon {
    id: number;
    machineInstallationName: string;
    machineSerialNumber: string;
    dateTime: Date;
    userKId: string;
    cServiceVersion: string;

    constructor() {
        this.machineSerialNumber = null;
        this.machineInstallationName = null;
        this.dateTime = null;
        this.userKId = null;
        this.cServiceVersion = null;
    }

    public parse(obj: any) {
        if (obj.MachineSerialNumber) this.machineSerialNumber = obj.MachineSerialNumber;
        if (obj.MachineInstallationName) this.machineInstallationName = obj.MachineInstallationName;
        if (obj.DateTime) this.dateTime = new Date(obj.DateTime);
        if (obj.UserKId) this.userKId = obj.UserKId;
        if (obj.CServiceVersion) this.cServiceVersion = obj.CServiceVersion;
    }
}
